<template>
  <div id="download">
    <div class="download_nav"></div>
    <div class="download_container">
      <div class="download_title">下载标准版</div>
      <div class="condition">
        <!-- <p class="tiaoj" style="margin-bottom: 30px">这是一款免费软件。</p> -->
        <!-- <p class="tiaoj" style="margin-bottom: 30px">
          只能用做模拟交易。
        </p> -->
        <div class="title">使用应满足的条件</div>
        <div class="cond_detail">
          <p>1、X86架构的4核CPU/8G内存（RAM），或更高配置；</p>
          <p>2、windows10、windows11等64位操作系统；</p>
          <p>3、建议用电信、联通宽带，其它宽带会有卡顿的问题。</p>
        </div>
        <div class="download_detail">
          <p class="verson">版本：{{ banben }}</p>
          <p class="Size">大小：{{ daxiao }}</p>
          <p class="Update">更新：{{ gengxin }}</p>
          <div class="download_btn">
            <div class="telecom" @click="dldianx()">电信下载</div>
            <div class="unicom" @click="dlwangt()">联通下载</div>
          </div>
        </div>
      </div>
      <div class="register">
        <div class="title">软件登录</div>
        <!-- <p style="margin-bottom:15px">
          不需要注册账号，用默认账号（guest）可直接登录行情，如下图所示。
        </p> -->
        <div style="text-align: center">
          <img src="https://wh-api.wenhua.com.cn/api/WhBanner/GetWhBannerUrl?id=90" alt="" />
        </div>
        <p>
          注册后，基本功能免费使用，收费功能可以体验一个月。
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      dianx: "",
      wangt: "",
      banben: "加载中...",
      daxiao: "加载中...",
      gengxin: "加载中...",
    };
  },
  methods: {
    dldianx() {
      if (this.dianx == "") {
        return;
      } else {
        // axios
        //   .get("/update/api/Update/SetCount", {
        //     params: {
        //       type: 3,
        //     },
        //   })
           window.location.href = this.dianx;
       
      }
    },
    dlwangt() {
      if (this.wangt == "") {
        return;
      } else {
        // axios
        //   .get("/update/api/Update/Getcount", {
        //     params: {
        //       type: 3,
        //     },
        //   })
            window.location.href = this.wangt;
      }
    },
  },

  mounted() {

    axios.get("https://webapi.wenhua.com.cn/update/api/Update/GetUpdateInfo?appid=26").then((res) => {
      console.log(res)
      if (res.data.Status) {
        console.log(res.data)
        var data=JSON.parse(res.data.ResultData)
        console.log(data)
        this.dianx = 'https://ftpc.wenhua.com.cn/files/wh5_setup_'+data.Version+'.exe';
        this.wangt = 'https://ftpc1.wenhua.com.cn/files/wh5_setup_'+data.Version+'.exe';
        this.banben = data.Version;
        this.daxiao = data.Size;
        this.gengxin = data.UpdateTime;
      }
    });
  },
};
</script>

<style scoped>
#download {
  position: relative;
  color: #7b7b7b;
}

.download_nav {
  height: 465px;
  width: 100%;
  background: url(https://wh-api.wenhua.com.cn/api/WhBanner/GetWhBannerUrl?id=12) no-repeat center top;
}

.download_container {
  width: 990px;
  height: 100%;
  position: relative;
  margin: -229px auto 0 auto;
  padding: 30px 30px 107px 30px;
  border-radius: 5px;
  background-color: #fff;
  box-shadow: 0 0 20px -5px #ccc;
}

.download_title {
  font-size: 22px;
  line-height: 40px;
  border-bottom: 1px dashed #a8a8a8;
}

.condition {
  margin-top: 34px;
  position: relative;
}

.title {
  height: 20px;
  line-height: 20px;
  font-size: 16px;
  color: #5c110e;
  padding-left: 8px;
  border-left: 4px solid #e04b48;
  font-weight: 700;
  margin-bottom: 18px;
}

.cond_detail {
  padding-left: 16px;
}

.cond_detail p {
  font-size: 14px;
  line-height: 30px;
}
.tiaoj {
  font-size: 14px;
  line-height: 30px;
}
.download_detail {
  width: 240px;
  position: absolute;
  top:63px;
  right: 60px;
}

.download_detail p {
  font-size: 12px;
  line-height: 23px;
}

.download_btn {
  margin-top: 15px;
  overflow: hidden;
}

.telecom,
.unicom {
  width: 110px;
  height: 32px;
  line-height: 32px;
  text-align: center;
  color: #fff;
  border-radius: 3px;
  font-size: 14px;
  cursor: pointer;
}

.telecom {
  background-color: #e1a27e;
  float: left;
}

.unicom {
  background-color: #b5734c;
  float: right;
}

.register {
  margin-top: 62px;
}

.register p {
  font-size: 14px;
  line-height: 30px;
  padding-left: 30px;
  margin-top: 10px;
}
</style>